import client from "../Client/HttpClient";
import { ICountriesModel } from "@/interfaces/modules";
const ApiPath = "SystemCountries";

export default {
  GetCountries: (): Promise<ICountriesModel[]> => client.get(`${ApiPath}`),
  GetCountriesById: (data: ICountriesModel): Promise<ICountriesModel> =>
    client.get(`${ApiPath}/${data.Id}`),
  PostCountries: (data: ICountriesModel): Promise<ICountriesModel> =>
    client.post(`${ApiPath}`, data),
};
